import React from 'react';

import { Control } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';

import { TruncatedText } from '../truncated-text/TruncatedText';

export const StreamLinkBase = ({
  streamId = undefined,
  stream = undefined,
  canView = true,
  route = undefined,
  hideId = false,
  size = 'large',
  placeholders = {},
  hasTruncatedLink = false,
  ...props
}) => {
  const { t } = useTranslation();

  if (!streamId) return '-';

  if (!stream && canView && hideId) return placeholders.removed ?? t('removed');
  if (!stream && !canView && hideId) return placeholders.unavailable ?? t('unavailable');
  if (!stream && !hideId) return streamId;

  return (
    <Control.Link
      data-testid={`CamLink-${streamId}`}
      size={size}
      target="_blank"
      to={generatePath(route, { streamId: stream.streamId })}
      {...props}
    >
      <TruncatedText
        hasTruncation={hasTruncatedLink}
        tooltipContent={stream.label}
      >
        {stream.label}
      </TruncatedText>
    </Control.Link>
  );
};

StreamLinkBase.propTypes = {
  streamId: PropTypes.string,
  stream: PropTypes.object,
  canView: PropTypes.bool,
  route: PropTypes.string,
  hideId: PropTypes.bool,
  size: PropTypes.string,
  placeholders: PropTypes.shape({
    removed: PropTypes.string,
    unavailable: PropTypes.string,
  }),
  hasTruncatedLink: PropTypes.bool,
};
